var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef, memo } from "react";
var SvgFacialBalance = function SvgFacialBalance(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 20 20",
    stroke: "currentColor",
    role: "img",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    d: "M17.5 4.167c0 6.443-3.358 11.666-7.5 11.666S2.5 10.61 2.5 4.167"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.7,
    d: "M6.667 10.403c.256-.105 1.252-.757 1.538-1.203.385-.6 1.41-.6 1.795 0 .384-.597 1.41-.597 1.923 0 .599.698 1.154 1.098 1.41 1.203m-6.666 0c.427.56 1.923 1.68 3.333 1.68 1.666 0 2.863-1.12 3.333-1.68m-6.666 0h6.666"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeDasharray: "3 3",
    strokeLinecap: "round",
    d: "M10 18.333V1.667"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgFacialBalance);
var Memo = /*#__PURE__*/memo(ForwardRef);
export default Memo;